// handle voting
export function registerVoting() {
  const votes = document.getElementsByClassName("btn-like");
  const ids = [];

  for (let likeBtn of votes) {
    let id = likeBtn.dataset.id;
    if (ids.indexOf(id) === -1 && !likeBtn.dataset.ok) {
      ids.push(id);
    }
  }

  // mark as voted
  fetch(`/api/memes/voted?ids=${ids.join(",")}`)
    .then((res) => res.json())
    .then((json) => {
      for (const key in json) {
        const direction = json[key];
        const likeBtn = document.querySelector(`[data-id="${key}"][data-type="${direction}"]`);
        if (likeBtn) {
          likeBtn.classList.add("liked-" + direction);
        }
      }
    });

  for (let likeBtn of votes) {
    if (!likeBtn.dataset.ok) {
      let id = likeBtn.dataset.id;
      let likes = parseInt(likeBtn.dataset.likes);
      let direction = likeBtn.dataset.type;
      let opposite = direction === "up" ? "down" : "up";

      function handleLike(e) {
        e.stopImmediatePropagation();
        fetch(`/api/mem/${id}/like?type=${direction}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        })
          .then((res) => res.json())
          .then((json) => {
            if (json.ok) {
              let text = likeBtn.getElementsByTagName("span")[0];

              if (!likeBtn.classList.contains("liked-" + direction)) {
                text.innerText = likes + 1;
                likeBtn.classList.add("liked-" + direction);
              } else {
                text.innerText = parseInt(text.innerText) - 1;
                likeBtn.classList.remove("liked-" + direction);
              }

              // opposite button
              const oppositeBtn = document.querySelector(`[data-id="${id}"][data-type="${opposite}"]`);
              if (oppositeBtn) {
                if (oppositeBtn.classList.contains("liked-" + opposite)) {
                  oppositeBtn.classList.remove("liked-" + opposite);
                  let text2 = oppositeBtn.getElementsByTagName("span")[0];
                  text2.innerText = parseInt(text2.innerText) - 1;
                }
              }
            }
          });
      }

      likeBtn.addEventListener("click", handleLike);
      likeBtn.dataset.ok = true;
    }
  }
}
